import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { DARK_HERO_BAND_HEIGHT, DARK_HERO_BAND_HEIGHT_MOBILE } from '@/styles/darkHero.ts';

import SearchTool from './SearchTool.jsx';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        background: `linear-gradient(${theme.palette.common.secondary} 0 ${DARK_HERO_BAND_HEIGHT}px, transparent ${DARK_HERO_BAND_HEIGHT}px)`,
        [theme.breakpoints.down('sm')]: {
            background: `linear-gradient(${theme.palette.common.secondary} 0 ${DARK_HERO_BAND_HEIGHT_MOBILE}px, transparent ${DARK_HERO_BAND_HEIGHT_MOBILE}px)`,
        },
    },
    inner: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: theme.layout.contentWidth,
        width: '100%',
        padding: '32px 50px 4rem 50px',

        [theme.breakpoints.down('sm')]: {
            paddingTop: '24px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '24px 20px 4rem 20px',
        },
    },
    fullHeight: {
        minHeight: '70vh',
    },
}));

const SearchHero = ({ fullHeight = false, showBrowse = true }) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={clsx(classes.inner, fullHeight && classes.fullHeight)}>
                <SearchTool showBrowse={showBrowse} />
            </div>
        </div>
    );
};

export default SearchHero;
